<!-- 网关 -->
<style lang="scss" scoped>
.getaway {
  position: relative;
}
.returnScence {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.returnScence2 {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 213px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.dialogContent {
  position: absolute;
  right: 43px;
  top: 135px;
  .container-div {
    padding: 20px;
    .container-item {
      color: white;
      display: flex;
      justify-content: space-between;
    }
  }
}
.equ {
  position: absolute;
  top: 135px;
  left: 107px;
  width: 415px;
  height: 198px;
  .lifts {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data {
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number {
        font-size: 48px;
        font-family: "dina";
      }
    }
    .data:nth-child(1) {
      .number {
        color: #2d82ff;
      }
    }
    .data:nth-child(2) {
      .number {
        color: #f1802f;
      }
    }
  }
}
</style>
<template>
  <div class="getaway">
    <div class="returnScence" @click="returnScence"></div>
    <!-- <div
      class="returnScence2"
      @click="returnScence2"
      v-show="isShowParkingNormal"
    ></div> -->
    <div class="equ">
      <custom-plane
        title="网关"
        :iconImg="require('@/assets/compImg/icon/icon-wg.png')"
      >
        <div class="lifts">
          <div v-for="(item, index) in GatewayList" :key="index" class="data">
            <p>{{ item.title }}</p>
            <p class="number">{{ item.num }}</p>
          </div>
        </div>
      </custom-plane>
    </div>

    <div class="dialogContent" v-if="showDialog">
      <gate-way :headerName="'网关'" :pannelDatas="showDataList"></gate-way>
    </div>
  </div>
</template>
<script>
import bus from "@/components/three-scene/Bus.js";
import { getEqpInfo, getGatewayData } from "@/api";
export default {
  data() {
    return {
      isShowReturn: false,
      isShowParkingNormal: false,
      showDialog: false,
      gateWayMap: {
        name: "网关名称",
        hardwareId: "mac地址",
        version: "固件版本",
        networkingType: "连网方式",
        ipAddress: "IP地址",
        positionCode: "网关编码",
        position: "安装位置",
        usage: "网关用途",
        lastHeartbeat: "最近心跳包时间",
        gatewayOnlineStatus: "在线状态",
        powerSupplyStatus: "供电状态",
        remark: "备注",
        offlineTime: "离线时间",
      },
      GatewayList: [
        { title: "正常数量", num: "-" },
        { title: "离线数量", num: "-" },
      ],
      showDataList: {},
      timer: null,
    };
  },
  created() {
    this.getGatewayData();
    this.timer = setInterval(() => {
      this.getGatewayData();
    }, 30*60*1000);
  },
  mounted() {
    this.$store.state.threeEvent.intoGateway = true;
    bus.emit("openFloorLabel", true);
    bus.on("setName", this.getBuild);
    bus.emit("showFloorPoint", "网关", true);
    bus.on("dialogNumber", this.openDialog);
    bus.on("parkingArea2", this.clickParking);
  },
  methods: {
    async getGatewayData() {
      let { data: res } = await getGatewayData();
      if (res) {
        let { offline, online } = res;
        this.GatewayList = [
          { title: "正常数量", num: online },
          { title: "离线数量", num: offline },
        ];
      }
    },
    clickParking() {
      this.isShowParkingNormal = true;
    },
    returnScence2() {
      bus.emit("parking-mr");
      this.isShowParkingNormal = false;
    },
    async openDialog(eqpCode) {
      let { data: res } = await getEqpInfo({ eqpCode });
      if(res?.baseData){
      console.log(res.baseData, "123123123");
      this.showDataList = res.baseData;
      delete this.showDataList.offlineInterval;
      }

      // this.showDataList.$remove("offlineInterval");
      this.showDialog = true;
    },
    getBuild(name) {
      this.isShowReturn = true;
    },
    returnScence() {
      bus.emit("back");
      this.showDialog = false;
      this.isShowReturn = false;
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
